module.exports = __webpack_public_path__ + "img/span.ca9fc8d5.svg";